import { render, staticRenderFns } from "./standardAttributes.vue?vue&type=template&id=877b61ec&scoped=true"
import script from "./standardAttributes.vue?vue&type=script&lang=js"
export * from "./standardAttributes.vue?vue&type=script&lang=js"
import style0 from "./standardAttributes.vue?vue&type=style&index=0&id=877b61ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877b61ec",
  null
  
)

export default component.exports